export const stripePublishableKey =
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || "";

export const graphql = {
  url: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || "",
};

export const cognitoConfig = {
  userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID ?? "",
  clientId: process.env.NEXT_PUBLIC_AWS_USER_POOL_WEB_CLIENT_ID ?? "",
  region: process.env.NEXT_PUBLIC_AWS_REGION ?? "",
};

export const defaultMerchantSlug =
  process.env.NEXT_PUBLIC_DEFAULT_MERCHANT_SLUG ?? "";

export const supabaseConfig = {
  url: process.env.NEXT_PUBLIC_SUPABASE_URL ?? "",
  key: process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ?? "",
};

export const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? "";

export const basicAuth = {
  user: process.env.BASIC_AUTH_USER ?? "admin",
  pass: process.env.BASIC_AUTH_PASS ?? "baldr123",
};
